import script from "./BeforeTwoFactorAuthentication.vue?vue&type=script&setup=true&lang=js"
export * from "./BeforeTwoFactorAuthentication.vue?vue&type=script&setup=true&lang=js"

import "./BeforeTwoFactorAuthentication.vue?vue&type=style&index=0&id=a1c09e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1c09e4e"]])

export default __exports__